(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bo-collection"] && !Shopify.designMode) return;
  try {
    
  // Sep 16 — preserve scroll position when clicking a filter link (mobile flash-to-top)
  try { history.scrollRestoration = 'manual'; } catch(_) {}
  document.addEventListener('click', function(e){
    var link = e.target.closest('.bo-col__side-fx-value, .bo-col__tf-value, .bo-col__sf-value, .bo-col__chip');
    if (!link) return;
    try { sessionStorage.setItem('boColScrollY', String(window.scrollY || window.pageYOffset || 0)); } catch(_) {}
  });
  (function(){
    var saved;
    try { saved = sessionStorage.getItem('boColScrollY'); } catch(_) { saved = null; }
    if (saved === null) return;
    try { sessionStorage.removeItem('boColScrollY'); } catch(_) {}
    var y = parseInt(saved, 10);
    if (isNaN(y)) return;
    // wait for layout to be ready, then jump
    requestAnimationFrame(function(){ window.scrollTo(0, y); });
  })();
  // Close top-filter dropdowns on outside click
  document.addEventListener('click', function(e){
    var opens = document.querySelectorAll('[data-bo-topfilters] details[open]');
    opens.forEach(function(d){ if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  // "Toon meer producten" — fetch next page, append its grid cards, update button URL
  document.addEventListener('click', async function(e){
    var btn = e.target.closest('[data-bo-loadmore]');
    if (!btn) return;
    var url = btn.dataset.nextUrl;
    if (!url) return;
    btn.classList.add('is-loading');
    btn.disabled = true;
    try {
      var res = await fetch(url, { headers: { 'Accept': 'text/html' } });
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('[data-bo-grid]');
      var newBtn  = doc.querySelector('[data-bo-loadmore]');
      var grid    = document.querySelector('[data-bo-grid]');
      if (newGrid && grid) {
        var frag = document.createDocumentFragment();
        Array.from(newGrid.children).forEach(function(node){ frag.appendChild(node); });
        grid.appendChild(frag);
      }
      if (newBtn) {
        btn.dataset.nextUrl = newBtn.dataset.nextUrl;
        var cnt = doc.querySelector('[data-bo-count]');
        var localCnt = document.querySelector('[data-bo-count]');
        if (cnt && localCnt) localCnt.innerHTML = cnt.innerHTML;
      } else {
        var wrap = btn.closest('[data-bo-loadmore-wrap]');
        if (wrap) wrap.innerHTML = '<p class="bo-col__loadmore-count">U hebt alle artikelen bekeken.</p>';
      }
    } catch (err) {
      console.error('load-more failed', err);
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
    btn.classList.remove('is-loading');
    btn.disabled = false;
  });
  // Open/close "Alle filters" drawer
  document.addEventListener('click', function(e){
    var openBtn = e.target.closest('[data-bo-openall]');
    var closeBtn = e.target.closest('[data-bo-closeall]');
    var drawer = document.getElementById('bo-col-drawer');
    if (!drawer) return;
    if (openBtn) { drawer.hidden = false; document.body.style.overflow = 'hidden'; }
    else if (closeBtn || (e.target === drawer && !drawer.hidden)) { drawer.hidden = true; document.body.style.overflow = ''; }
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    var drawer = document.getElementById('bo-col-drawer');
    if (drawer && !drawer.hidden) { drawer.hidden = true; document.body.style.overflow = ''; }
  });
  // Sticky mobiele balk — "Sorteren" opent de bestaande sorteer-select
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-bo-focus-sort]');
    if (!b) return;
    var sel = document.getElementById('bo-sort');
    if (!sel) return;
    try { sel.focus(); sel.click(); } catch (err) {}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-existing-customer"] && !Shopify.designMode) return;
  try {
    
  // If the URL has ?u=<id> or ?uuid=<id>, surface a small "we recognized you" note
  (function(){
    var qs = new URLSearchParams(window.location.search);
    var id = qs.get('u') || qs.get('uuid') || qs.get('contact');
    if (!id) return;
    var note = document.querySelector('[data-bo-ec-uuidnote]');
    var key  = document.querySelector('[data-bo-ec-uuidkey]');
    if (note && key) {
      key.textContent = id.slice(0, 8) + (id.length > 8 ? '…' : '');
      note.style.display = 'flex';
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
